export var IIdentityVerificationField;
(function (IIdentityVerificationField) {
    let Type;
    (function (Type) {
        Type["RESELLER_ID"] = "RESELLER_ID";
        Type["EIN"] = "EIN";
        Type["DESCRIPTION"] = "DESCRIPTION";
        Type["WEBSITE_URL"] = "WEBSITE_URL";
        Type["FACEBOOK_URL"] = "FACEBOOK_URL";
        Type["STORE_IMAGES"] = "STORE_IMAGES";
        Type["SALES_RANGE"] = "SALES_RANGE";
        Type["YEAR_ESTABLISHED"] = "YEAR_ESTABLISHED";
        Type["FREE_FORM_QUESTION"] = "FREE_FORM_QUESTION";
        Type["FREE_FORM_QUESTION_2"] = "FREE_FORM_QUESTION_2";
        Type["FREE_FORM_QUESTION_3"] = "FREE_FORM_QUESTION_3";
        Type["LEASE_TIME"] = "LEASE_TIME";
        Type["RESALE_CERTIFICATES"] = "RESALE_CERTIFICATES";
        Type["BANK_STATEMENTS"] = "BANK_STATEMENTS";
        Type["CREDIT_CARD_STATEMENTS"] = "CREDIT_CARD_STATEMENTS";
        Type["OPEN_DATE"] = "OPEN_DATE";
        Type["ADDRESS"] = "ADDRESS";
        Type["VAT"] = "VAT";
        Type["LEASE_DOCUMENTS"] = "LEASE_DOCUMENTS";
        Type["WEBSITE_IMAGES"] = "WEBSITE_IMAGES";
        /**
         * @deprecated
         */
        Type["PROOF_OF_POPUP"] = "PROOF_OF_POPUP";
        Type["PROOF_OF_POP_UP"] = "PROOF_OF_POP_UP";
        Type["EORI"] = "EORI";
        Type["STORE_PICTURES_WITH_SIGNAGE"] = "STORE_PICTURES_WITH_SIGNAGE";
        Type["DBA_NAME_CERTIFICATE"] = "DBA_NAME_CERTIFICATE";
        Type["FREE_FORM_FILE1"] = "FREE_FORM_FILE1";
        /**
         * @deprecated
         */
        Type["FREE_FORM_FILE1_LABEL"] = "FREE_FORM_FILE1_LABEL";
        Type["FREE_FORM_FILE2"] = "FREE_FORM_FILE2";
        /**
         * @deprecated
         */
        Type["FREE_FORM_FILE2_LABEL"] = "FREE_FORM_FILE2_LABEL";
        Type["FREE_FORM_FILE3"] = "FREE_FORM_FILE3";
        Type["TAX_LICENSE_OR_RESELLER_PERMIT_PROOF"] = "TAX_LICENSE_OR_RESELLER_PERMIT_PROOF";
        Type["ABN"] = "ABN";
        Type["PHONE_CALL"] = "PHONE_CALL";
        Type["ONE_YEARS_TAX_RETURN"] = "ONE_YEARS_TAX_RETURN";
        Type["TWO_YEARS_TAX_RETURN"] = "TWO_YEARS_TAX_RETURN";
        Type["CREDIT_CHECK_AUTHORIZATION"] = "CREDIT_CHECK_AUTHORIZATION";
        Type["BANK_FREE_FORM_QUESTION"] = "BANK_FREE_FORM_QUESTION";
        Type["BANK_FREE_FORM_QUESTION_2"] = "BANK_FREE_FORM_QUESTION_2";
        Type["BANK_FREE_FORM_QUESTION_3"] = "BANK_FREE_FORM_QUESTION_3";
        Type["FREE_FORM_QUESTION_4"] = "FREE_FORM_QUESTION_4";
        Type["FREE_FORM_FILE4"] = "FREE_FORM_FILE4";
    })(Type = IIdentityVerificationField.Type || (IIdentityVerificationField.Type = {}));
    /**
     * Return an instance of IIdentityVerificationField with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IIdentityVerificationField.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IIdentityVerificationField || (IIdentityVerificationField = {}));
